import styled from '@emotion/styled';
import { Magnetic } from '@mitchell/react.component.ux';
const IDENTIFY_MODAL_MIN_WIDTH = `calc(${Magnetic.spacer40} * 7)`;
const LINE_HEIGHT_14 = '1rem';
const LINE_HEIGHT_16 = '1.14rem';
const LINE_HEIGHT_24 = '1.71rem';
const shouldForwardInlineActionButtonProp = (prop) => prop !== 'isDisabled' && prop !== 'isSemibold';
export const StyledSendButton = styled('div') `
	margin: ${Magnetic.spacer12} 0;
	display: flex;
	justify-content: flex-end;
	width: 100%;
	button {
		width: auto;
		padding: 0 ${Magnetic.spacer12};
		margin-right: ${Magnetic.spacer12};
	}
`;
export const StyledFixedMenuWrapper = styled('div') `
	position: fixed;
	bottom: ${Magnetic.spacer16};
	right: ${Magnetic.spacer16};
	z-index: 1000;
	background-color: ${Magnetic.backgroundNeutral0};
	border-radius: 50%;
	box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
	display: flex;
	justify-content: center;
	align-items: center;
	width: 45px;
	height: 45px;
`;
export const StyledUploadStatusBanner = styled('div') `
	background-color: ${Magnetic.colorBrand10};
	color: ${Magnetic.colorNeutral60};
	padding: ${Magnetic.spacer08} ${Magnetic.spacer12};
	display: flex;
	align-items: center;
	font-size: ${Magnetic.fontSize12};
	line-height: ${LINE_HEIGHT_16};
`;
export const StyledUploadStatusIcon = styled('span') `
	color: ${Magnetic.colorBrand50};
	margin-right: ${Magnetic.spacer08};
	font-size: ${Magnetic.fontSize14};
`;
export const StyledUploadStatusProgressBar = styled('div') `
	padding: 0 0 ${Magnetic.spacer06};
`;
export const StyledDeleteModalBody = styled('div') `
	display: inline-flex;
	align-items: center;
	gap: ${Magnetic.spacer12};
	padding: ${Magnetic.spacer24} ${Magnetic.spacer32};
	background-color: ${Magnetic.colorNeutral5};
`;
export const StyledDeleteModalIcon = styled('span') `
	font-size: ${Magnetic.fontSize24};
	color: ${Magnetic.colorWarningText};
	line-height: 1;
`;
export const StyledDeleteModalMessage = styled('span') `
	font-size: ${Magnetic.fontSize16};
	font-weight: ${Magnetic.fontWeightSemibold};
	color: ${Magnetic.colorNeutral80};
`;
export const StyledDeleteActionIcon = styled('span') `
	font-size: ${Magnetic.fontSize20};
	color: ${props => (props.hasSelectedAttachments ? Magnetic.colorBrand50 : Magnetic.colorNeutral40)};
	cursor: ${Magnetic.actionableCursor};
	padding: ${Magnetic.spacer08};
	line-height: 1;
	@media (max-width: 30rem) {
		padding: ${Magnetic.spacer04};
		font-size: ${Magnetic.fontSize18};
	}
`;
export const StyledSelectionActionsRow = styled('div') `
	display: flex;
	align-items: center;
	justify-content: space-between;
	width: 100%;
	gap: ${Magnetic.spacer16};
	min-width: 0;

	@media (max-width: 30rem) {
		flex-wrap: nowrap;
		align-items: center;
		gap: ${Magnetic.spacer08};
	}
`;
export const StyledSelectionActionsGroup = styled('div') `
	display: flex;
	align-items: center;
	gap: ${Magnetic.spacer24};
	min-width: 0;
	flex: 1 1 auto;

	@media (max-width: 30rem) {
		flex-wrap: nowrap;
		gap: ${Magnetic.spacer08};
		overflow: hidden;
	}
`;
export const StyledInlineActionButton = styled('button', {
    shouldForwardProp: shouldForwardInlineActionButtonProp
}) `
	display: inline-flex;
	align-items: center;
	gap: ${Magnetic.spacer08};
	padding: 0;
	border: 0;
	background: transparent;
	font-size: ${Magnetic.fontSize16};
	font-weight: ${props => (props.isSemibold ? Magnetic.fontWeightSemibold : Magnetic.fontWeightRegular)};
	line-height: ${LINE_HEIGHT_24};
	color: ${props => (props.isDisabled ? Magnetic.colorNeutral40 : Magnetic.colorBrand50)};
	cursor: ${props => (props.isDisabled ? Magnetic.defaultCursor : Magnetic.actionableCursor)};
	white-space: nowrap;
	min-width: 0;

	&:focus {
		outline: none;
	}
	@media (max-width: 30rem) {
		white-space: nowrap;
		gap: ${Magnetic.spacer04};
		font-size: ${Magnetic.fontSize14};
		line-height: ${LINE_HEIGHT_16};
	}
`;
export const StyledInlineActionIcon = styled('span') `
	font-size: ${Magnetic.fontSize18};
	line-height: ${LINE_HEIGHT_14};
`;
export const StyledIdentifyModalBody = styled('div') `
	display: flex;
	flex-direction: column;
	gap: ${Magnetic.spacer08};
	width: 100%;
	min-width: ${IDENTIFY_MODAL_MIN_WIDTH};
	max-width: 100%;
	box-sizing: border-box;
	padding: ${Magnetic.spacer16} ${Magnetic.spacer16} ${Magnetic.spacer12};
	background-color: ${Magnetic.colorNeutral5};
	@media (max-width: 30rem) {
		min-width: 0;
	}
`;
export const StyledUploadModalContent = styled.div `
	display: flex;
	width: 100%;
	height: 100%;
	flex-direction: column;
`;
export const StyledFileCountModalBody = styled('div') `
	display: flex;
	justify-content: center;
	align-items: center;
	text-align: center;
	padding: ${Magnetic.spacer24} ${Magnetic.spacer32};
	font-size: ${Magnetic.fontSize16};
	color: ${Magnetic.colorNeutral80};
`;
export const StyledEditWrapper = styled('div') `
	margin-top: ${Magnetic.spacer20};
`;
//# sourceMappingURL=IntelligentAssignmentSummaryComponent.style.js.map